import { useNavigate } from "react-router-dom";
import MenuTop from "../../../../components/menu/top/menu-top";
import './style.css';
import { useEffect, useState } from "react";
import { fetchBeneficiariesService } from "../../../../features/beneficiary/service/beneficiary-service";
import Loader from "../../../../components/loader/loader";
import { ListComponent } from "../../../../components/list/list";
import MenuContext, { DISPLAY_TYPE } from "../../../../components/menu/context/menu-context";

export function ListBeneficiary() {
    const navigate = useNavigate();
    const [ isLoading, setIsLoading ] = useState(false);
    const [beneficiaries, setBeneficiaries] = useState<any[]>([]);

    useEffect(() => {
        const fetchBeneficiaries = async () => {
            try {
                setIsLoading(true);
                const [beneficiaries] = await Promise.all([
                    fetchBeneficiariesService(),
                ]);

                // Ordenar alfabeticamente pelo nome
                const sortedBeneficiaries = [...beneficiaries].sort((a, b) => {
                    const nameA = (a.name || '').toLowerCase();
                    const nameB = (b.name || '').toLowerCase();
                    return nameA.localeCompare(nameB, 'pt-BR');
                });

                setBeneficiaries(sortedBeneficiaries);
            } catch (error) {
                console.log(error);
            } finally {
                setIsLoading(false);
            }
        };

        fetchBeneficiaries();
    }, []);

    return (
        <div className="container-client">
            <MenuTop />
            {isLoading && <Loader />}
            <div className='container-client__content'>
                <div className="container-client__content__title">
                    <h1 className="container-client__content__title-text">Listagem de beneficiários</h1>
                    <MenuContext 
                        display={DISPLAY_TYPE.INLINE} 
                        clickedAdd={() => navigate('/beneficiario')}
                    />
                </div>
                
                {beneficiaries.length > 0 ? (
                    <ListComponent 
                        data={beneficiaries} 
                        handleRedirect={(id: string) => navigate(`/beneficiario/${id}`)}
                    />
                ) : (
                    !isLoading && <p className="empty-message">Nenhum beneficiário encontrado.</p>
                )}
            </div>
        </div>
    )
}